var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[(_vm.showTitle)?_c('common-title-panel',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle}}):_vm._e(),_c('div',{ref:"chart",style:({ width: '100%', height: _vm.chartHeight })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }